module.exports = ".container1 {\n  padding-left: 50px; }\n"